import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

/**
 * FI - Field Input riutilizzabile per tutti i questionari
 */
export function FI({ label, required, type = "text", value, onChange, tid, placeholder, hint }) {
  return (
    <div className="space-y-2">
      <Label className="text-sm text-[#0F1F14]">
        {label} {required && <span className="text-[#D97B58]">*</span>}
      </Label>
      {hint && <p className="text-[10px] text-[#4A5E51]">{hint}</p>}
      <Input
        type={type}
        value={value || ""}
        onChange={e => onChange(e.target.value)}
        className="rounded-xl border-[#E5E2DB] h-11 focus:ring-2 focus:ring-[#163321]/20 focus:border-[#163321]"
        placeholder={placeholder}
        data-testid={tid}
      />
    </div>
  );
}

/**
 * YN - Yes/No radio riutilizzabile per tutti i questionari
 */
export function YN({ label, required, field, formData, update, tid, hint }) {
  return (
    <div className="space-y-2">
      <Label className="text-sm text-[#0F1F14]">
        {label} {required && <span className="text-[#D97B58]">*</span>}
      </Label>
      {hint && <p className="text-[10px] text-[#4A5E51]">{hint}</p>}
      <RadioGroup value={formData[field] || ""} onValueChange={v => update(field, v)} className="flex gap-4">
        <div className="flex items-center gap-2">
          <RadioGroupItem value="si" id={`${field}-si`} data-testid={`${tid}-si`} />
          <Label htmlFor={`${field}-si`} className="text-sm cursor-pointer">S&igrave;</Label>
        </div>
        <div className="flex items-center gap-2">
          <RadioGroupItem value="no" id={`${field}-no`} data-testid={`${tid}-no`} />
          <Label htmlFor={`${field}-no`} className="text-sm cursor-pointer">No</Label>
        </div>
      </RadioGroup>
    </div>
  );
}
